const PolicyFallbackIcon = ({ width = 24, height = 24, fill = "#011851" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M3.6001 12.0001C3.6001 16.6388 7.36135 20.4001 12.0001 20.4001C16.6388 20.4001 20.4001 16.6388 20.4001 12.0001C20.4001 7.36135 16.6388 3.6001 12.0001 3.6001C7.36135 3.6001 3.6001 7.36135 3.6001 12.0001ZM7.97635 12.7763C8.20885 12.5438 8.59135 12.5438 8.82385 12.7763L10.7251 14.6776L15.1126 8.6476C15.3076 8.38135 15.6826 8.32135 15.9488 8.51635C16.2151 8.71135 16.2751 9.08635 16.0801 9.3526L11.2801 15.9526C11.1751 16.0951 11.0176 16.1851 10.8413 16.1963C10.6651 16.2076 10.4926 16.1476 10.3688 16.0238L7.96885 13.6238C7.73635 13.3913 7.73635 13.0088 7.96885 12.7763H7.97635Z"
      fill={fill}
    />
    <path
      d="M11.9999 21.5999C6.6974 21.5999 2.3999 17.3024 2.3999 11.9999C2.3999 6.6974 6.6974 2.3999 11.9999 2.3999C17.3024 2.3999 21.5999 6.6974 21.5999 11.9999C21.5999 17.3024 17.3024 21.5999 11.9999 21.5999ZM11.9999 3.5999C7.36115 3.5999 3.5999 7.36115 3.5999 11.9999C3.5999 16.6387 7.36115 20.3999 11.9999 20.3999C16.6387 20.3999 20.3999 16.6387 20.3999 11.9999C20.3999 7.36115 16.6387 3.5999 11.9999 3.5999ZM15.1162 8.6474C15.3112 8.38115 15.6862 8.32115 15.9524 8.51615C16.2187 8.71115 16.2787 9.08615 16.0837 9.3524L11.2837 15.9524C11.1787 16.0949 11.0212 16.1849 10.8449 16.1962C10.6687 16.2074 10.4962 16.1474 10.3724 16.0237L7.9724 13.6237C7.7399 13.3912 7.7399 13.0087 7.9724 12.7762C8.2049 12.5437 8.5874 12.5437 8.8199 12.7762L10.7212 14.6774L15.1087 8.6474H15.1162Z"
      fill={fill}
    />
  </svg>
);

export default PolicyFallbackIcon;
